import {
  Sidebar,
  SidebarDivider,
  SidebarGroup,
  SidebarItem,
  SidebarSpace,
  SidebarSubmenu,
  SidebarSubmenuItem,
} from '@backstage/core-components';

import { NavContentBlueprint } from '@backstage/plugin-app-react';
import { SidebarLogo } from './SidebarLogo';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import AppsIcon from '@material-ui/icons/Apps';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import DomainIcon from '@material-ui/icons/Domain';
import WebhookIcon from '@material-ui/icons/CallSplit';
import MemoryIcon from '@material-ui/icons/Memory';
import HomeIcon from '@material-ui/icons/Home';
import BusinessIcon from '@material-ui/icons/Business';
import GroupIcon from '@material-ui/icons/People';
import UserIcon from '@material-ui/icons/Person';
import AdminIcon from '@material-ui/icons/Security';
import VisualizerIcon from '@material-ui/icons/AccountTree';
import AnnouncementsIcon from '@material-ui/icons/Announcement';
import DevtoolsIcon from '@material-ui/icons/Build';
import TemplateIcon from '@material-ui/icons/Widgets';
import LocationIcon from '@material-ui/icons/LocationOn';
import DocumentationIcon from '@material-ui/icons/Description';
import ResourcesIcon from '@material-ui/icons/Storage';
import CreateIcon from '@material-ui/icons/AddCircleOutline';
import TasksIcon from '@material-ui/icons/Assignment';
import ActionsIcon from '@material-ui/icons/FlashOn';
import TemplateEditorIcon from '@material-ui/icons/Edit';
import ExtensionsIcon from '@material-ui/icons/Extension';
import { SidebarSearchModal } from '@backstage/plugin-search';
import { UserSettingsSignInAvatar } from '@backstage/plugin-user-settings';
import { NotificationsSidebarItem } from '@backstage/plugin-notifications';
import { MyGroupsSidebarItem } from '@backstage/plugin-org';

export const SidebarContent = NavContentBlueprint.make({
  params: {
    component: ({ navItems }) => {
      const nav = navItems.withComponent(item => (
        <SidebarItem icon={() => item.icon} to={item.href} text={item.title} />
      ));

      return (
        <Sidebar>
          <SidebarLogo />
          <SidebarGroup label="Search" icon={<SearchIcon />} to="/search">
            <SidebarSearchModal />
          </SidebarGroup>
          <SidebarDivider />
          <SidebarGroup label="Menu" icon={<MenuIcon />}>
            <SidebarItem
              icon={() => <HomeIcon />}
              to="/"
              text="Home"
            ></SidebarItem>
            <SidebarItem
              icon={() => <MenuBookIcon />}
              text="Catalog"
              to="/catalog"
            >
              <SidebarSubmenu title="Catalog">
                <SidebarSubmenuItem
                  title="Tenant"
                  to="/catalog?filters[kind]=tenant"
                  icon={BusinessIcon}
                />
                <SidebarSubmenuItem
                  title="Domain"
                  to="/catalog?filters[kind]=domain"
                  icon={DomainIcon}
                />
                <SidebarSubmenuItem
                  title="Application"
                  to="/catalog?filters[kind]=system"
                  icon={AppsIcon}
                />
                <SidebarSubmenuItem
                  title="Components"
                  to="/catalog?filters[kind]=component"
                  icon={MemoryIcon}
                />
                <SidebarSubmenuItem
                  title="Resources"
                  to="/catalog?filters[kind]=resource"
                  icon={ResourcesIcon}
                />
                <SidebarSubmenuItem
                  title="APIs"
                  to="/catalog?filters[kind]=api"
                  icon={WebhookIcon}
                />
                <SidebarSubmenuItem
                  title="Template"
                  to="/catalog?filters[kind]=template"
                  icon={TemplateIcon}
                />
              </SidebarSubmenu>
            </SidebarItem>
            <SidebarItem
              icon={() => <VisualizerIcon />}
              to="/catalog-graph"
              text="Knowledge Graph"
            />

            <SidebarItem
              icon={() => <CreateIcon />}
              text="Create"
              to="/create/templates"
            >
              <SidebarSubmenu title="Create">
                <SidebarSubmenuItem
                  title="Templates"
                  to="/create/templates"
                  icon={TemplateIcon}
                />
                <SidebarSubmenuItem
                  title="Tasks"
                  to="/create/tasks"
                  icon={TasksIcon}
                />
                <SidebarSubmenuItem
                  title="Actions"
                  to="/create/actions"
                  icon={ActionsIcon}
                />
                <SidebarSubmenuItem
                  title="Extensions"
                  to="/create/templating-extensions"
                  icon={ExtensionsIcon}
                />
                <SidebarSubmenuItem
                  title="Template editor"
                  to="/create/edit"
                  icon={TemplateEditorIcon}
                />
              </SidebarSubmenu>
            </SidebarItem>
            <SidebarDivider />
            <SidebarItem
              text="Documentation"
              to="/docs"
              icon={DocumentationIcon}
            />
            <SidebarDivider />

            <MyGroupsSidebarItem
              singularTitle="My Group"
              pluralTitle="My Groups"
              icon={GroupIcon}
            />
            <SidebarItem
              text="Announcements"
              to="/announcements"
              icon={AnnouncementsIcon}
            />
            <SidebarDivider />
            {/*<SidebarScrollWrapper>
              {nav.rest({ sortBy: 'title' })}
            </SidebarScrollWrapper>*/}
          </SidebarGroup>
          <SidebarSpace />
          <SidebarDivider />
          <NotificationsSidebarItem />
          <SidebarDivider />
          <SidebarGroup
            label="Settings"
            icon={<UserSettingsSignInAvatar />}
            to="/settings"
          >
            {nav.take('page:user-settings')}
            <SidebarItem
              icon={() => <AdminIcon />}
              text="Admin"
              to="/catalog?filters[kind]=Group"
            >
              <SidebarSubmenu title="Admin">
                <SidebarSubmenuItem
                  title="Groups"
                  to="/catalog?filters[kind]=group"
                  icon={GroupIcon}
                />
                <SidebarSubmenuItem
                  title="Users"
                  to="/catalog?filters[kind]=user"
                  icon={UserIcon}
                />
                <SidebarSubmenuItem
                  title="Locations"
                  to="/catalog?filters[kind]=location"
                  icon={LocationIcon}
                />
                <SidebarSubmenuItem
                  title="Visualizer"
                  to="/visualizer/tree"
                  icon={VisualizerIcon}
                />
                <SidebarSubmenuItem
                  title="Announcements Admin"
                  to="/announcements/admin"
                  icon={AnnouncementsIcon}
                />
                <SidebarSubmenuItem
                  title="Devtools"
                  to="/devtools"
                  icon={DevtoolsIcon}
                />
              </SidebarSubmenu>
            </SidebarItem>
          </SidebarGroup>
        </Sidebar>
      );
    },
  },
});
